import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    CalculationsModuleName,
    CardConfigModuleName,
    MULTICOLUMN_LIST_MODULE_NAME,
    UserServiceModuleName
} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName, UtilsModuleName} from "../utils/names/requiredModulesNames";
import {NavigationItem} from "../main/model/navigationItem";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {CALCULATIONS_SERVICE_NAME} from "../utils/names/serviceNames";
import {LoaderStatusValue} from "../loader/service/loaderStatus";
import {ILogService} from "angular";
import {getTabName} from "modules/utils/TabNameUtils";

export const CalculationModuleConfiguration = new RestrictedRouteModuleConfiguration(
    "CALCULATIONS",
    [
        CalculationsModuleName,
        UtilsModuleName,
        AngularJsMaterialModuleName,
        MULTICOLUMN_LIST_MODULE_NAME,
        CardConfigModuleName,
        //theese are needed bc our dependency injection sucks
        UserServiceModuleName
    ],
    [
        ["/calculations", {
            template: require('./html/calculations.html'),
            controller: 'calculationsController',
            resolve: {
                calculations: [
                    CALCULATIONS_SERVICE_NAME, 'LoaderStatusValue', '$log',
                    function (calculationService, loaderStatus: LoaderStatusValue, $log: ILogService) {
                        $log.debug('Fetching calculations');
                        loaderStatus.on();
                        return calculationService.getCalculations()
                            .then(resp => {
                                loaderStatus.off();
                                return resp.data;
                            });
                    }
                ]
            }
        }]
    ],
    [
        new NavigationItem({
            title: "Calculations",
            href: "#!calculations",
            activeFunction: routeName => routeName.indexOf('calculations') !== -1
        })
    ],
    [CalculationsModuleName],
    [UserGranredAuthorityName.CALCULATIONS],
    getTabName() + '| Calculations'
);

export default CalculationModuleConfiguration;